// Anmeldekriterium.KriteriumArt. The backend stores a raw int (no enum/constant), so every consumer keeps its
// own copy — keep client/, registration/ and fundraising/ identical. NOT booking/, which maps
// Buchungskriterium (its own 1–5 domain).
export default {
    TYPE_QUESTION: 1, // is also single, multiple and should be textarea
    TYPE_HEADING: 2,
    TYPE_PLACEHOLDER: 3, // carries the page-break flag (Seitenumbruch) when set
    TYPE_TEXT: 4,
    TYPE_QUANTITY: 5,
    TYPE_DATE: 6,
    TYPE_CERTIFICATE: 7,
    TYPE_FILE: 8, // authorable in client/; no public-form renderer yet
    TYPE_BLOCK: 9,
}
